interface SearchStatus {
  show: boolean;
  message: string;
  severity: "success" | "warning";
  pages: number[];
}

interface UseSearchControlsProps {
  isSearchActive: boolean;
  searchStatus?: SearchStatus; // Optional - replaced by NotificationSnackBar
  onSearchClick: () => void;
  onClearSearch: () => void;
  onCloseSearchStatus?: () => void; // Optional - replaced by NotificationSnackBar
}

export interface SearchControlsProps {
  isSearchActive: boolean;
  searchStatus?: SearchStatus;
  onSearchClick: () => void;
  onClearSearch: () => void;
  onCloseSearchStatus?: () => void;
}

export const useSearchControls = (
  props: UseSearchControlsProps,
): SearchControlsProps => {
  return {
    isSearchActive: props.isSearchActive,
    searchStatus: props.searchStatus,
    onSearchClick: props.onSearchClick,
    onClearSearch: props.onClearSearch,
    onCloseSearchStatus: props.onCloseSearchStatus,
  };
};
